<template>
    <div class="planner-calendar">
        <v-sheet
            :class="'cust-page-calendar cust-calendar cust-planner-calendar elevation-1'"
            elevation="0"
        >
            <v-toolbar flat dense class="cust-calendar-toolbar" height="39">
                <v-btn
                    fab
                    text
                    x-small
                    color="grey darken-2"
                    @click="onCalendarWeekClick(-1)"
                >
                    <v-icon small> mdi-chevron-left </v-icon>
                </v-btn>
                <v-menu 
                    v-model="selectDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290"
                >

                    <template v-slot:activator="{ on, attrs }">
                        <v-toolbar-title
                            v-bind="attrs"
                            v-on="on" 
                        >
                            {{ currentWeekDatesString }}
                        </v-toolbar-title>
                    </template>
                    <v-date-picker
                        v-model="selectedDate"
                        @input="selectDateMenu = false"
                        color="teal"
                        :min="'2025-01-01'"
                        :max="'2026-12-31'"
                        :first-day-of-week="1"
                    >
                    </v-date-picker>
                </v-menu>
                
                <v-btn
                    fab
                    text
                    x-small
                    color="grey darken-2"
                    @click="onCalendarWeekClick(+1)"
                >
                    <v-icon small> mdi-chevron-right </v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <div class="status-panel">
                    <v-chip-group
                        v-if="false"
                        :value="getCalendarPeriod"
                        active-class="active-panel-item"
                        mandatory
                        column
                    >
                        <v-chip
                            value="week"
                            class="ma-2"
                            small
                            label
                            @click="onPeriodChange('week')"
                        >
                            <v-icon class="mr-1"> fas fa-calendar-week </v-icon>
                            {{ $t("Неделя") }}
                        </v-chip>
                        <v-chip
                            value="month"
                            class="ma-2"
                            small
                            label
                            @click="onPeriodChange('notDistributed')"
                        >
                            <v-icon class="mr-1"> fas fa-calendar-alt </v-icon>
                            {{ $t("Не_распределенные") }}
                        </v-chip>
                    </v-chip-group>
                </div>
            </v-toolbar>
        </v-sheet>

        <div class="events-board-parent-box">
            <div
                v-for="item in filteredEventGroups"
                :key="item.key"
                class="events-board-item"
                :style="{ background: '#A4B7C9' }"
            >
                <div
                    class="events-board-item-top-part"
                    :style="{ background: '#A4B7C9' }"
                >
                    <div class="d-flex align-center mb-2">
                        <div class="ebi-title font-weight-bold">
                            {{ $t(item.name) }}, {{ $moment(item.date).locale($i18n.locale).format("LL")}}
                        </div>
                        <v-popover
                            v-if="userEnterprise == enterprise"
                            :trigger="'click'"
                            class="ebi-menu ml-auto"
                            @click.native.stop
                        >
                            <i class="fas fa-ellipsis-v"></i>
                            <template slot="popover">
                                <ul class="ribbon-button-submenu">
                                    <li
                                        @click.stop="$emit('planner-calendar-add-event-click', item.key)"
                                        v-close-popover
                                    >
                                        <v-icon left> far fa-plus </v-icon>
                                        <template>
                                            {{ $t("Добавить_мероприятие") }}
                                        </template>
                                    </li>
                                </ul>
                                <template>
                                    <span class="ribbon-button-submenu-title">{{
                                        $t("Действия")
                                    }}</span>
                                </template>
                            </template>
                        </v-popover>
                    </div>
                    <div class="d-flex align-center mb-2">
                        <div class="ebi-title">
                            {{ $t("Элементов") }}:
                            <span>{{ item.events.length }}</span>
                        </div>
                    </div>
                </div>

                <!--мероприятия-->
                <div
                    v-for="event in item.events"
                    :class="{ 'ebi-event-box': true, 'ebi-event-box-active': selectedMeetingId == event.id }"
                    :key="event.id"
                    @click="$emit('planner-calendar-event-click', event.id)"
                    @dblclick="$emit('planner-calendar-event-dbl-click', { id: event.id, type: 'None.PlannedMeeting' })"
                >
                    <div class="d-flex align-top">
                        <i
                            :class="[ event.status == 1 ? 'fas' : 'far', 'fa-check-circle', 'ebi-event-status' ]"
                            :style="{ color: event.status == 1 ? 'green' : '' }"
                            @click.stop="$emit('planner-calendar-change-status-click', { id: event.id, key: item.key })"
                        ></i>
                        <div class="ebi-event-title">{{ event.subject }}</div>
                        <v-popover
                            :trigger="'click'"
                            class="ebi-event-action-btn ml-auto"
                            @click.native.stop
                        >
                            <i class="fas fa-ellipsis-v"></i>
                            <template slot="popover">
                                <ul class="ribbon-button-submenu">
                                    <li
                                        @click.stop="$eventBus.$emit('open-document', { id: event.id, type: 'None.PlannedMeeting' })"
                                        v-close-popover
                                    >
                                        <v-icon left>
                                            far fa-file-spreadsheet
                                        </v-icon>
                                        <template> Открыть </template>
                                    </li>
                                    <li
                                        v-if="userEnterprise == enterprise"
                                        @click.stop="$emit('planner-calendar-delete-event-click', event.id)"
                                        v-close-popover
                                    >
                                        <v-icon left> far fa-trash-alt </v-icon>
                                        <template> Удалить </template>
                                    </li>
                                </ul>
                                <template>
                                    <span class="ribbon-button-submenu-title">Действия</span>
                                </template>
                            </template>
                        </v-popover>
                    </div>
                    <div class="ebi-footer-chips">
                        <div
                            class="d-flex align-center"
                            v-if="getChipsData(event.tags).length > 0"
                        >
                            <div class="onlyReadData more-per-lab-wrap">
                                <v-tag-chip
                                    v-for="(chip, i) in getChipsData(event.tags)"
                                    :key="i"
                                    :name="$t(chip.Value)"
                                    :chipColor="chip.color"
                                    :icon="chip.icon"
                                    chipOpacity="1"
                                    textColor="#fff"
                                    iconColor="#fff"
                                />
                            </div>
                        </div>
                        <div
                            class="onlyReadData"
                            v-if="event.curator_workplace_id"
                        >
                            <v-workplace-chip
                                :id="event.curator_workplace_id"
                                :name="getWorkplaceName(event.curator_workplace_id)"
                                :canDelete="false"
                            />
                        </div>
                        <div class="d-flex align-center">
                            <v-spacer></v-spacer>
                            <div class="ebi-fc-icon-text">
                                <i class="fas fa-comments-alt"></i>
                                {{ event.comments }}
                            </div>
                            <div class="ebi-fc-icon-text">
                                <i class="fas fa-paperclip"></i>
                                {{ event.attachments }}
                            </div>
                            <div
                                v-if="event.controller_workplace_id"
                                class="ebi-fc-icon-text"
                                @click.stop="produceGlobalEvent(event.controller_workplace_id)"
                            >
                                <i
                                    v-if="!photoMap[event.controller_workplace_id]"
                                    class="fas fa-user-circle ebi-event-user-icon"
                                />
                                <v-img
                                    v-else
                                    :src="photoMap[event.controller_workplace_id]"
                                    :lazy-src="photoMap[event.controller_workplace_id]"
                                    width="21"
                                    height="21"
                                    max-width="21"
                                    max-height="21"
                                    class="rounded-circle"
                                />
                            </div>
                            <div v-else style="width: 28px"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import "moment/locale/ru";
import "moment/locale/kk";

import { mapGetters } from "vuex";

export default {
    name: "EventsPlannerCalendar",
    props: {
        filteredEventGroups: {
            type: Array,
            default: () => [],
        },
        getChipsData: Function,
        getWorkplaceName: Function,
        onCalendarSelectWeek: Function,
        selectedMeetingId: {
            type: String,
            default: null,
        },
        photoMap: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        getCalendarPeriod: "week",
        selectDateMenu: false,
    }),
    computed: {
        ...mapGetters("global/auth", { userEnterprise: "getUserEnterpriseId" }),
        ...mapGetters("planner", { enterprise: "getFilterEnterprise" }),
        selectedDate: {
            get() {
                return this.$store.getters['planner/getCalendarDate']
            },
            set(v){
                this.$store.commit('planner/SET_CALENDAR_DATE', v );
                this.onCalendarSelectWeek()
            }
        },
        selectedWeek: {
            get() {
                const momentDate = this.$moment(this.selectedDate);
                return [momentDate.startOf("isoWeek").format('YYYY-MM-DD'), momentDate.endOf("isoWeek").format('YYYY-MM-DD') ];
            },
            set(v){
                this.selectedDate = v[0];
            }
        },
        currentWeekDatesString() {
            let first = this.$moment(this.selectedDate).startOf("isoWeek");
            let last = first.clone().add(6, "days").format("DD.MM.YYYY");
            return `${first.format("DD.MM.YYYY")} - ${last}`;
        },
    },
    methods: {
        onPeriodChange(type) {
            console.log(type);
        },
        produceGlobalEvent(id) {
            if (id) this.$eventBus.$emit("show-workplace-information", id);
        },
        onCalendarWeekClick(value){
            if (value < 0)
                this.selectedDate = this.$moment(this.selectedDate).subtract(1, 'week').startOf("isoWeek").format("YYYY-MM-DD");
            else if (value > 0)
                this.selectedDate = this.$moment(this.selectedDate).add(1, 'week').startOf("isoWeek").format("YYYY-MM-DD");
        },
        getCurrentWeekDatesString() {
            return this.currentWeekDatesString;
        }
    },
};
</script>